const baseUrl = `${window.location.protocol}//${window.location.host}`

export const oidcConfig = {
  authority: process.env.REACT_APP_OIDC_ISSUER,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
  redirect_uri: `${baseUrl}/login`,
  post_logout_redirect_uri: `${baseUrl}/logout`,
  scope: "openid email profile",
  revokeTokensOnSignout: true,
}

export const OIDC_LOGOUT_URL = `${oidcConfig.authority}/v2/logout?returnTo=${oidcConfig.post_logout_redirect_uri}&client_id=${oidcConfig.client_id}`
